export type ID = string;

export interface BaseEntity {
    id?: ID;
}
